import { Variables } from "./Variables";
import triggerIcon from "../../../../new-images/profile/trigger-icon.svg";
import triggerIconSuccess from "../../../../new-images/profile/trigger-icon-success.svg";
import successImg from "../../../../new-images/profile/success.svg";
import closeIcon from "../../../../new-images/profile/close-icon.svg";
import ErrorMessage from "../../../errorMessage";
import Input from "../../ui/input/Input";
import styles from "../trigger.module.scss";
import PhoneInput from "../../../phoneInput";

export const usePhoneVariables = (errors, count, value, setValue, confirmCode, setConfirmCode) => {

  return new Variables(
    {
      title: "Пожалуйста, добавьте номер",
      bold: " телефона",
      img: triggerIcon,
      prompt:
        "Укажите номер телефона, чтобы оставаться на связи и повысить безопасность вашей страницы. Номер телефона не будет виден другим пользователям сервиса.",
      label: "Номер телефона",
      button: "Подтвердить телефон",
      errorMessage: (
        <div>
          <ErrorMessage text={errors} />
        </div>
      ),
      htmlElement: (
        <PhoneInput
          onChange={(e) =>
            setValue({ value: e.target.value, label: e.target.value })
          }
          name={"phone"}
          value={value.label}
        />
      ),
    },
    {
      title: "Подтверждение телефона",
      img: triggerIconSuccess,
      label: "Код подтверждения",
      message: "Номер подтвержден",
      succesImg: successImg,
      htmlElement: (
        <Input
          placeholder={"Код из смс"}
          defaultValue={confirmCode}
          disabled={true}
        />
      ),
    },
    {
      title: "Подтверждение телефона",
      img: closeIcon,
      typeImg: "close",
      label: "Введите код из смс, который придет на",
      labelBold: ` +${value.label}`,
      button: "Подтвердить",
      typeButton: "confirm",
      counter: `${
        count > 0
          ? `Выслать код повторно через ${count} сек`
          : "Выслать код повторно"
      }`,
      errorCode: (
        <div className={styles.TriggerHtmlElement__errorBlock}>
          <ErrorMessage text={errors} />
        </div>
      ),
      htmlElement: (
        <Input
          placeholder={"Код из смс"}
          value={confirmCode}
          onChange={(e) => setConfirmCode(e.target.value)}
        />
      ),
    }
  )
};
